import { createApp } from 'vue'
import PercentageCalculator from './PercentageCalculator.vue'
import './assets/global.css'

createApp(PercentageCalculator).mount('#percentage')
